import React, { useState, useEffect } from "react";
import { useParams, useLocation } from "react-router-dom";
import { loadStripe } from "@stripe/stripe-js";
import { HashRouter as Router, Route, Switch } from "react-router-dom";
import SuccessPayment from "./SuccessPayment";
import FailedPayment from "./FailedPayment";
import Loader from "./Loader/Loader";
import { useHistory } from "react-router-dom";
import {
  PayPalScriptProvider,
  PayPalButtons,
  PayPalMessages,
} from "@paypal/react-paypal-js";
import SideFrame from "../src/assets/side_frame.png";
import CodeYoung from "../src/assets/codeyoung_logo_mobile.svg";
import makeStyles from "@mui/styles/makeStyles";
import { useTheme, useMediaQuery } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { Row, Col, Container } from "react-bootstrap";
import ArrowUp from "./assets/arrow_up.png";
import ArrowDown from "./assets/arrow_down.png";
import ArrowDownCatalyst from "./assets/catalyst_arrow_down.png";
import ArrowUpCatalyst from "./assets/catalyst_arrow_up.png";
import Bullet from "./assets/bullet_desktop.png";
import catalystSideFrame from "./assets/catalyst_side_banner.png";
import catalyst from "./assets/catalyst_logo.png";
import Success from "./Success";
import PaymentExpiry from "./PaymentExpiry";
import moment from "moment";
import razorpayCheckout from "./Razorpay";
import payglocal from "./payglocal";

import {
  browserName,
  isMobile,
  isTablet,
  isDesktop,
} from "react-device-detect";
import { stopLoader } from "./utils/LoaderUtils";
import ErrorPage from "./ErrorPage";
import CheckoutPage from "./CheckoutPage";

const {
  REACT_APP_URL,
  REACT_APP_STRIPE_KEY,
  REACT_APP_PAYPAL_CLIENT_ID,
  REACT_APP_PAYPAL_PAYLATER_CLIENT_ID,
} = process.env;

const useStyles = makeStyles((theme) => ({
  title: {
    fontSize: "28px",
    color: "#444444",
    fontWeight: "600",
    [theme.breakpoints.down("sm")]: {
      fontSize: "18px",
      textAlign: "center",
    },
  },
  subTitle: {
    fontSize: "16px",
    color: "#555555",
    fontWeight: "400",
    [theme.breakpoints.down("sm")]: {
      fontSize: "14px",
      textAlign: "center",
    },
  },
  rightBox: {
    marginTop: "40px",
  },
  fieldBox: {
    background: "#FFFFFF",
    borderRadius: "10px",
    padding: "15px",
    marginTop: "20px",
  },
  fieldName: {
    color: "#999999",
    fontSize: "16px",
    fontWeight: "500",
    [theme.breakpoints.down("sm")]: {
      fontSize: "14px",
    },
  },
  fieldValue: {
    color: "#444444",
    fontSize: "18px",
    fontWeight: "600",
    [theme.breakpoints.down("sm")]: {
      fontSize: "16px",
    },
  },
  period: {
    fontWeight: "400",
  },
  convenienceFeesBox: {
    borderRadius: "4px",
    background: "#F6F4F4",
    textAlign: "center",
    color: "#999999",
    fontSize: "12px",
    paddingTop: "8px",
    paddingBottom: "8px",
    lineHeight: "18px",
    [theme.breakpoints.down("sm")]: {
      paddingTop: "5px",
      paddingBottom: "5px",
    },
    fontFamily: "Poppins",
  },
  infoIcon: {
    marginBottom: "0.20em",
    marginRight: "0.25em",
  },
  refundPolicyBox: {
    // boxShadow: "0px 1px 8px rgba(129, 11, 11, 0.08)",
    background: "#FFF",
    // padding: "0 15px",
    //height: "56px",
    padding: "15px",
    height: "auto",
    borderRadius: "10px",
    //display: "flex",
    alignItems: "center",
  },
  refundPolicyPoints: {
    paddingLeft: "5px",
    fontSize: "16px",
    fontWeight: "400",
    color: "#555555",
  },
  checkoutButton: {
    background: "#FF712D",
    border: "none",
    width: "100%",
    color: "#FFFFFF",
    fontSize: "18px",
    fontWeight: "600",
    borderRadius: "5px",
    padding: "7px",
  },
  subscriptionNoteBox: {
    width: "70%",
    [theme.breakpoints.down("sm")]: {
      width: "80%",
    },
  },
  subscriptionNote: {
    color: "#5181FF",
    fontSize: "14px",
    fontWeight: "500",
    textAlign: "center",
  },
  checkboxContainer: {
    width: "100%",
    padding: "0px 4px",
    display: "flex",
    marginTop: "30px",
    marginBottom: "15px",
  },
  checkBoxText: {
    margin: "-2px 0px 0px 10px",
    fontFamily: "Poppins",
    fontStyle: "normal",
    fontWeight: "400",
    fontSize: "12px",
    lineHeight: "18px",
    color: "#555555",
    [theme.breakpoints.down("xs")]: {
      fontSize: "10px",
      lineHeight: "15px",
    },
  },
  anchorTag: {
    color: "#555555",
  },
  checkmarkFieldText: {
    display: "flex",
    width: "100%",
    justifyContent: "center",
    textAlign: "center",
    marginTop: "5px",
    color: "#dc3545",
    fontFamily: "Poppins",
    fontSize: "14px",
    lineHeight: "18px",
    [theme.breakpoints.down("xs")]: {
      fontSize: "10px",
      lineHeight: "15px",
    },
  },
  catalystButton: {
    background: "#4917B0",
    border: "none",
    width: "100%",
    color: "#FFFFFF",
    fontSize: "18px",
    fontWeight: "600",
    borderRadius: "5px",
    padding: "7px",
  },
  normalHr: {
    border: "1px solid #FF9A6C",
    margin: 0,
    opacity: 1,
  },
  catalystHr: {
    border: "1px solid #FFD6C2",
    opacity: 1,
  },
}));

// Make sure to call `loadStripe` outside of a component’s render to avoid
// recreating the `Stripe` object on every render.
const stripePromise = loadStripe(REACT_APP_STRIPE_KEY);
const ProductDisplay = () => {
  const classes = useStyles();
  const theme = useTheme();
  const isSmall = useMediaQuery(theme.breakpoints.down("xs"));
  const isTabletOrMobile = useMediaQuery(theme.breakpoints.down("md"));

  const [tokenStatus, setTokenStatus] = useState(false);
  const [payment, setPayment] = useState({});
  const [registrationDetails, setRegistrationDetails] = useState({}); //Used for Stripe Subs
  const [subscribedFor, setSubscribedFor] = useState(null);
  const [order, setOrder] = useState([]);
  const [selfCheckoutDetails, setSelfCheckoutDetails] = useState({});
  const [isSelfCheckout, setIsSelfCheckout] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [success, setSuccess] = useState(false);
  const [vendor, setVendor] = useState("");
  const [paypalPlanId, setPaypalPlanId] = useState("");
  const [showRefundPolicy, setShowRefundPolicy] = useState(false);
  const [subscriptionDuration, setSubscriptionDuration] = useState("");
  const [parentPhone, setParentPhone] = useState();
  const [robticsCourseId, setRoboticsCourseId] = useState("");
  const [refundPolicyPointList, setRefundPolicyPointList] = useState([]);
  const [policy, setPolicy] = useState();
  const [convenienceFees, setConvenienceFees] = useState(0);
  const [showClickCheckMark, setShowClickCheckMark] = useState(false);
  const [submit, setSubmit] = useState(true);
  const [expiry, setExpiry] = useState(false);
  const [isPaymentLoading, setIsPaymentLoading] = useState(false);
  const [ipAddress, setIpAddress] = useState("");
  const [browserInfo, setBrowserInfo] = useState({});
  const [businessUnitId, setBusinessUnitId] = useState(1);
  const [isFullpayment, setIsFullpayment] = useState(false);
  const [xpayLink, setXpayLink] = useState("");
  const [subscriptionPeriodInterval, setSubscriptionPeriodInterval] =
    useState(1);
  const [maxExpiryDate, setMaxExpiryDate] = useState("");
  const [addOnDetails, setAddOnDetails] = useState({});
  const [bannerImg, setBannerImg] = useState({});

  const shouldAllowScroll = isDesktop && (order.length > 1 || isSelfCheckout);
  const { id } = useParams();
  const history = useHistory();
  const orderFlowName = new URLSearchParams(useLocation().search).get(
    "orderFlowName",
  );

  const roundHalf = (num) => {
    return (Math.round(num * 2) / 2).toFixed(2);
  };

  const formatSubscriptionFrequency = ({
    period,
    interval = 1,
    isForBlueNote = false,
    isSmall = false,
  }) => {
    if (!period) return "";

    if (isForBlueNote) {
      return interval === 1
        ? period === "monthly"
          ? "every month"
          : period === "weekly"
            ? "every week"
            : period === "yearly"
              ? "every year"
              : `every ${period}`
        : period === "monthly"
          ? `every ${interval} months`
          : period === "weekly"
            ? `every ${interval} weeks`
            : period === "yearly"
              ? `every ${interval} years`
              : `every ${interval} ${period}`;
    }

    if (interval === 1) {
      return isSmall
        ? period === "monthly"
          ? "mo."
          : period === "weekly"
            ? "wk."
            : period === "yearly"
              ? "yr."
              : period
        : period === "monthly"
          ? "month"
          : period === "weekly"
            ? "week"
            : period === "yearly"
              ? "year"
              : period;
    } else {
      return period === "monthly"
        ? `${interval} mo.`
        : period === "weekly"
          ? `${interval} wk.`
          : period === "yearly"
            ? `${interval} yr.`
            : `${interval} ${period}`;
    }
  };

  const handleCheckboxChange = (e) => {
    setSubmit(e.target.checked);
    setShowClickCheckMark(false);
  };

  const colStyleForScroll = {};

  // const colStyleForScroll =
  //   isTablet || isDesktop
  //     ? { height: "calc(100vh - 150px)", overflowX: "auto" }
  //     : {};

  useEffect(() => {
    fetch("https://api.ipify.org?format=json")
      .then((response) => response.json())
      .then((data) => {
        setIpAddress(data.ip);
      })
      .catch((error) => console.log("Error fetching IP address:", error));

    const getBrowserDetails = () => {
      let browser = browserName ? { browserName } : { browserName: "Unknown" };
      if (isDesktop) {
        browser.deviceType = "Desktop";
      } else if (isTablet) {
        browser.deviceType = "Tablet";
      } else if (isMobile) {
        browser.deviceType = "Mobile";
      } else {
        browser.deviceType = "Unknown";
      }

      let userAgent = navigator.userAgent;
      if (userAgent.match(/chrome|chromium|crios/i)) {
        browser.browserVersion = `Chrome v${userAgent.split("Chrome/")[1]}`;
      } else if (userAgent.match(/firefox|fxios/i)) {
        browser.browserVersion = `Firefox v${userAgent.split("Firefox/")[1]}`;
      } else if (userAgent.match(/safari/i)) {
        browser.browserVersion = `Safari v${userAgent.split("Safari/")[1]}`;
      } else if (userAgent.match(/edg/i)) {
        browser.browserVersion = `Edg v${userAgent.split("Edg/")[1]}`;
      } else {
        browser.version = "No Version detected";
      }
      return browser;
    };
    const browser = getBrowserDetails();
    setBrowserInfo(browser);

    if (orderFlowName) {
      window.localStorage.setItem("orderFlowName", orderFlowName);
    }
  }, []);

  useEffect(() => {
    const checkPaymentDone = async () => {
      setLoading(true);
      try {
        // in future if there is a custom url we can use thes api for setting the url from EpicenterApi
        const response = await fetch(`${REACT_APP_URL}/checkPayment`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify({ paymentId: id }),
        });
        if (!response.ok) {
          throw new Error("Something went Wrong");
        }

        const data = await response.json();

        setBusinessUnitId(data?.businessUnitId);
        setTokenStatus(data?.tokenAmountStatus);
        setParentPhone(data?.parentContact);
        if (data?.subsPlanId) {
          setPaypalPlanId(data.subsPlanId);
        }
        if (data?.robticsCourseId) {
          setRoboticsCourseId(data.robticsCourseId);
        }
        if (data?.vendor) {
          setVendor(data.vendor);
        }
        if (!data.tokenAmountStatus) {
          setLoading(true);
          const response = await fetch(`${REACT_APP_URL}/get/payment/details`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
            },
            body: JSON.stringify({ paymentId: id }),
          });
          if (!response.ok) {
            throw new Error("Something went Wrong");
          }
          const data = await response.json();
          setBannerImg(data?.banners);
          setOrder(data.orderDetails);
          setAddOnDetails(data?.addOnDetails);
          if (
            data?.selfCheckoutOrderDetails &&
            data?.orderDetails.length === 0 &&
            Object.keys(data?.selfCheckoutOrderDetails).length > 0
          ) {
            setIsSelfCheckout(true);
            setSelfCheckoutDetails(data.selfCheckoutOrderDetails);
          } else {
            setIsSelfCheckout(false);
          }

          setPayment(data.paymentDetails);
          setRegistrationDetails(data.installmentDetails);
          setSubscribedFor(data.subscriptionPlan.period);
          setRefundPolicyPointList(data.refundPolicyPointList);
          setPolicy(data.policy);
          setConvenienceFees(data.convenienceFees);
          setIsFullpayment(data.isFullpayment);
          if (data?.maxExpiryDate) {
            setMaxExpiryDate(data.maxExpiryDate);
          }

          const intervalValue =
            data.subscriptionPlan?.subscriptionPeriodInterval || 1;
          setSubscriptionPeriodInterval(intervalValue);
          setSubscriptionDuration((data.totalInstallments - 1) * intervalValue);
          setLoading(false);
          if (data.xpayPaymentLink) {
            setXpayLink(data.xpayPaymentLink);
          }

          const currentUTCTime = moment.utc();

          if (data?.paymentDetails?.type === "Token") {
            const duration = moment.duration(
              currentUTCTime.diff(data?.paymentDetails?.createdAt),
            );
            const isMoreThan15Days = duration.asDays() > 15;
            if (isMoreThan15Days) {
              setExpiry(true);
            }
          }
        }
        setLoading(false);
      } catch (e) {
        console.log("error: ", e);
        setLoading(false);
        setError(true);
      }
    };
    checkPaymentDone();
  }, [id]);

  useEffect(() => {
    if (success) {
      history.push(`/success/${id}`);
    }
  }, [history, id, subscribedFor, success]);

  const userConsent = async () => {
    try {
      const countryId = isSelfCheckout
        ? selfCheckoutDetails?.currencyId
        : order[0].countryId;
      const masterOrderId = payment.orderId;
      const paymentId = payment.paymentId;

      const response = await fetch(`${REACT_APP_URL}/userConsent`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          countryId,
          masterOrderId,
          paymentId,
          ipAddress,
          ...browserInfo,
        }),
      });
      if (!response.ok) {
        throw new Error("Unable to get user consent details.");
      }
      await response.json();
    } catch (err) {
      console.log("error while getting user info: ", err);
    }
  };

  const getPayload = () => {
    if (isSelfCheckout) {
      return JSON.stringify({
        courseName: "CODEYOUNG_COURSES(SESSION)",
        currency: selfCheckoutDetails?.currencyId,
        amount: payment?.amount,
        id,
        CourseId: "mxbhd",
        robticsCourseId,
      });
    } else {
      return JSON.stringify({
        courseName: order?.[0]?.courseName,
        currency: order?.[0]?.currencyId,
        amount: payment?.amount,
        id,
        CourseId: order?.[0]?.CourseId,
        robticsCourseId,
      });
    }
  };

  const handleClick = async (e) => {
    if (!submit) {
      setShowClickCheckMark(true);
      return;
    }

    setIsPaymentLoading(true);
    try {
      await userConsent();
      if (vendor === "stripe") {
        const stripe = await stripePromise;

        const response = await fetch(
          `${REACT_APP_URL}/create-checkout-session`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
            },
            body: getPayload(),
          },
        );

        const session = await response.json();

        // When the customer clicks on the button, redirect them to Checkout.
        const result = await stripe.redirectToCheckout({
          sessionId: session.id,
        });

       
      } else if (vendor === "razorpay") {
        e.preventDefault();
        await razorpayCheckout({
          amount: payment?.amount,
          merchantOrderId: payment?.merchantOrderId,
          currency: isSelfCheckout
            ? selfCheckoutDetails?.currencyId
            : order?.[0]?.currencyId,
          subscribedFor,
          setError,
          setSuccess,
        });
        return;
      } else if (vendor === "payglocal") {
        e.preventDefault();
        const response = await fetch(`${REACT_APP_URL}/get/payglocal-link`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify({ paymentId: id }),
        });
        const data = await response.json();
        const link = data?.link;
        await payglocal({
          link,
          setError,
          setSuccess,
        });
      } else if (vendor === "xPay") {
        e.preventDefault();
        window.location.href = xpayLink;
      }
    } catch (error) {
      console.error("Payment error:", error);
    } finally {
      setIsPaymentLoading(false);
    }
  };

  return error ? (
    <ErrorPage />
  ) : !tokenStatus ? (
    <div>
      {loading ? (
        <Loader />
      ) : expiry ? (
        <PaymentExpiry paymentDetails={payment} orderDetails={order} />
      ) : (
        <CheckoutPage
          // Order data
          order={order}
          isSelfCheckout={isSelfCheckout}
          selfCheckoutDetails={selfCheckoutDetails}
          maxExpiryDate={maxExpiryDate}
          // Payment data
          payment={payment}
          registrationDetails={registrationDetails}
          subscribedFor={subscribedFor}
          subscriptionDuration={subscriptionDuration}
          subscriptionPeriodInterval={subscriptionPeriodInterval}
          convenienceFees={convenienceFees}
          // Vendor and policy
          vendor={vendor}
          policy={policy}
          paypalPlanId={paypalPlanId}
          refundPolicyPointList={refundPolicyPointList}
          businessUnitId={businessUnitId}
          isFullpayment={isFullpayment}
          xpayLink={xpayLink}
          // Handlers and state
          handleClick={handleClick}
          setError={setError}
          setSuccess={setSuccess}
          submit={submit}
          setSubmit={setSubmit}
          showClickCheckMark={showClickCheckMark}
          setShowClickCheckMark={setShowClickCheckMark}
          isPaymentLoading={isPaymentLoading}
          // Utils
          browserInfo={browserInfo}
          ipAddress={ipAddress}
          paymentId={id}
          addOnDetails={addOnDetails}
          bannerImg={bannerImg}
        />
      )}
    </div>
  ) : (
    <SuccessPayment id={id} />
  );
};

const Message = ({ message, id }) => {
  return message === "success" ? <SuccessPayment id={id} /> : <ErrorPage />;
};

export default function App() {
  const [message, setMessage] = useState("");
  const [id, setId] = useState("");

  useEffect(() => {
    // Check to see if this is a redirect back from Checkout
    const query = new URLSearchParams(window.location.search);
    if (query.get("success") && query.get("id")) {
      setId(query.get("id"));
      setMessage("success");
    }

    if (query.get("canceled")) {
      setMessage(
        "Order canceled -- continue to shop around and checkout when you're ready.",
      );
    }
    stopLoader();
  }, []);

  return (
    <Router>
      {message ? (
        <Message message={message} id={id} />
      ) : (
        <Switch>
          <Route path="/:success/:transactionId">
            <Success />
          </Route>
          <Route exact path="/:id" component={ProductDisplay} />
        </Switch>
      )}
    </Router>
  );
}
